import React from 'react';
import {AccentColorOptions} from 'epic-ue-theme';
import styled from 'styled-components';
import {Typography} from '../typography';
import { RemoveIcon } from '../icons';

export interface TagPillProps {
    accentColor?: AccentColorOptions;
    label?: string;
    hideX?: boolean;
}

const Styled = styled.div`
    cursor: pointer;

    background-color: ${(p) => p.theme.palette.neutral.concrete};
    color: ${(p) => p.theme.palette.common.white};
    display: inline-block;
    width: fit-content;
    border-radius: 16px;
    padding: 0px 20px;

    margin-right: 10px;
    font-size: 14px;
    letter-spacing: 2px;

    white-space: nowrap;

    .tag-pill-p {
        display: flex;
        align-items: center;
        span {
            padding-right: 8px;
        }
        svg {
            font-size: 16px;
            transition: transform 0.2s ${(p) => p.theme.easing};
        }
    }

    &:hover {
        .tag-pill-p svg {
            transform: scale(1.15, 1.15);
            transition: none;
        }
    }
`;

export const TagPill = ({label = '', hideX = false}: TagPillProps): JSX.Element => {
    return (
        <Styled className="tag-pill">
            <Typography className="tag-pill-p" variant="p">
                <span>{label}</span>
                {!hideX && <RemoveIcon />}
            </Typography>
        </Styled>
    );
};
